module.exports = __webpack_public_path__ + "static/3-002-5c34fbaa1038d3014c2169340e846db7.mp4";